<template>
  <div class="let-page-title">Vejledninger</div>
</template>

<style lang="scss"></style>
